module.exports = __webpack_public_path__ + "img/iconos1.18a7f48c.png";